import { Dimensions, SelectedDimensions } from 'components/control-panel/types'

import { Business } from './auth'
import { Page } from './page'
import { User } from './user'

export interface AccessProfile {
  id: number | string
  label: string
  description: string
  isOmniAccess: boolean
  isArchived: boolean
  business: Business
  users: User[]
  readonlyPages: Page[]
  editablePages: Page[]
  type: AccessProfileType
  sharedWithId?: number | string
  sharedWith?: Business
  dimensions: Dimensions
}

// TODO: This list should also contain Pages, do this once we have fixed the Page Type
// We are only using page.title and page.id in access management, so we should be fine for now
export const ACCESS_PROFILE_CASE_CONVERSION_EXCLUDE: string[] = [
  'users',
  'business',
  'shared_with',
  'dimensions'
]

export interface AccessProfilePayload extends AccessProfile, SelectedDimensions {
  readonlyPageIds: string[]
  editablePageIds: string[]
  userIds: string[]
}

export enum AccessProfileUserRole {
  MEMBER = 'access_profile_user',
  ADMIN = 'access_profile_admin'
}

export enum AccessProfilePagePermission {
  VIEW = 'view',
  EDIT = 'edit'
}

export enum AccessProfileType {
  INTERNAL = 'internal',
  SHARED = 'shared'
}

export const isInternalAccessProfile = (type: AccessProfileType) =>
  type === AccessProfileType.INTERNAL
export const isSharedAccessProfile = (type: AccessProfileType) => type === AccessProfileType.SHARED
